import { useState, useEffect } from "react";

const RelojDigital = () => {
  const [time, setTime] = useState(new Date());
  const [sidebarAbierto, setSidebarAbierto] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    const observer = new MutationObserver(() => {
      setSidebarAbierto(!document.body.classList.contains("sidebar-collapse"));
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);

  // Formateo de la fecha: convierte el resultado a minúsculas y pone en mayúscula solo la primera letra.
  const formatDate = (date) => {
    const formatted = date.toLocaleDateString("es-ES", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    return formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase();
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  // El color y la tipografia los define el tema en sistema-diseno.css, para
  // que el reloj siga siendo legible tanto en el tema oscuro como en el claro.
  return (
    <div className="reloj-container text-center">
      <div className="d-block d-md-none d-lg-block">
        <div className={`hora ${sidebarAbierto ? "d-block" : "d-none"}`}>
          {formatTime(time)}
        </div>
        <div className={`fecha mb-2 ${sidebarAbierto ? "d-block" : "d-none"}`}>
          {formatDate(time)}
        </div>
      </div>
    </div>
  );
};

export default RelojDigital;
